module.exports = __webpack_public_path__ + "6fb523d0f027de4143e86a22aaeda6c5.mp3";


//////////////////
// WEBPACK FOOTER
// ./static/audios/500_r_20.mp3
// module id = 427
// module chunks = 0